
/* ==========================================
   BOWKS | DESKTOP BOTTOM SHEET MEGA MENU
   Dawn Compatible
   v1.0
========================================== */

(() => {
  "use strict";

  const CLOSE_DURATION = 750;

  function initBowksMegaMenu() {
    const menus = Array.from(
      document.querySelectorAll(".bowks-mega")
    );

    menus.forEach((mega) => {
      if (mega.dataset.bowksReady === "true") return;

      const summary = mega.querySelector(":scope > summary");
      const closeButton = mega.querySelector(".bowks-mega__close");
      const content = mega.querySelector(".bowks-mega__content");

      if (!summary || !content || !closeButton) return;

      mega.dataset.bowksReady = "true";

      const toggles = Array.from(
        mega.querySelectorAll(".bowks-mega__toggle")
      );

      let closeTimer = null;

      function getPanel(toggle) {
        const id = toggle.getAttribute("aria-controls");
        return id ? document.getElementById(id) : null;
      }

      /* ACCORDION */

      function closeToggle(toggle) {
        const panel = getPanel(toggle);
        if (!panel) return;

        toggle.setAttribute("aria-expanded", "false");
        panel.classList.remove("is-open");
        panel.inert = true;
      }

      function closeAllToggles() {
        toggles.forEach(closeToggle);
      }

      function toggleAccordion(toggle) {
        const panel = getPanel(toggle);
        if (!panel) return;

        const isOpen =
          toggle.getAttribute("aria-expanded") === "true";

        if (isOpen) {
          closeToggle(toggle);
          return;
        }

        toggles.forEach((other) => {
          if (other !== toggle) closeToggle(other);
        });

        toggle.setAttribute("aria-expanded", "true");
        panel.inert = false;
        panel.classList.add("is-open");
      }

      /* OPEN / CLOSE */

      function clearCloseTimer() {
        if (closeTimer !== null) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function openMega() {
        clearCloseTimer();
        mega.classList.remove("is-closing");

        menus.forEach((other) => {
          if (other !== mega && other.open) {
            other.open = false;
            other.classList.remove("is-closing");
          }
        });

        mega.open = true;
        summary.setAttribute("aria-expanded", "true");
      }

      function finishClose() {
        mega.open = false;
        mega.classList.remove("is-closing");
        summary.setAttribute("aria-expanded", "false");
        closeAllToggles();
        clearCloseTimer();
      }

      function closeMega() {
        if (!mega.open || mega.classList.contains("is-closing")) {
          return;
        }

        mega.classList.add("is-closing");
        summary.setAttribute("aria-expanded", "false");

        closeTimer = setTimeout(
          finishClose,
          CLOSE_DURATION
        );
      }

      function toggleMega() {
        if (mega.open && !mega.classList.contains("is-closing")) {
          closeMega();
        } else {
          openMega();
        }
      }

      /* CLICK HANDLING */

      mega.addEventListener("click", (event) => {
        const close = event.target.closest(".bowks-mega__close");

        if (close && mega.contains(close)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          closeMega();
          return;
        }

        const toggle = event.target.closest(".bowks-mega__toggle");

        if (toggle && mega.contains(toggle)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          toggleAccordion(toggle);
          return;
        }

        const clickedSummary = event.target.closest("summary");

        if (clickedSummary === summary) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          toggleMega();
        }
      }, true);

      /* ESCAPE KEY */

      mega.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;

        event.preventDefault();
        event.stopPropagation();
        closeMega();
        summary.focus();
      }, true);

      /* OUTSIDE CLICK */

      document.addEventListener("click", (event) => {
        if (!mega.open) return;
        if (mega.contains(event.target)) return;

        closeMega();
      });

      /* STATE RESET */

      const observer = new MutationObserver(() => {
        if (!mega.open) {
          clearCloseTimer();
          mega.classList.remove("is-closing");
          summary.setAttribute("aria-expanded", "false");
          closeAllToggles();
        }
      });

      observer.observe(mega, {
        attributes: true,
        attributeFilter: ["open"]
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBowksMegaMenu);
  } else {
    initBowksMegaMenu();
  }

  document.addEventListener(
    "shopify:section:load",
    initBowksMegaMenu
  );
})();
